<template>
  <div class="text-heading">
    <slot v-if="$slots.pre" name="pre" />

    <h1 v-if="$slots.title" class="text-heading__title super-title3">
      <slot name="title" />
    </h1>

    <h2 v-if="$slots.subtitle" class="text-heading__subtitle title1">
      <slot name="subtitle" />
    </h2>
    <h2 v-if="$slots.sectiontitle" class="text-heading__sectiontitle title1">
      <slot name="sectiontitle" />
    </h2>

    <div v-if="iconName" class="text-heading__icon">
      <FontIcon :name="iconName" />
    </div>

    <div v-if="$slots.after" class="text-heading__after text2">
      <slot name="after" />
    </div>
  </div>
</template>

<style lang="scss">
.text-heading {
  margin: rem(40px) auto rem(35px);
  max-width: $width-outer;
  width: 100%;
  text-align: center;
  position: relative;

  &__title,
  &__subtitle,
  &__sectiontitle {
    @include setColor(--color-text);
  }

  &__icon {
    font-size: rem(90px);
  }

  &__subtitle,
  &__sectiontitle {
    margin-bottom: rem(36px);
  }

  &__after {
    text-align: center;
  }
}
</style>

<script>
import FontIcon from "../FontIcon/FontIcon";

export default {
  components: {
    FontIcon,
  },

  props: {
    iconName: {
      type: String,
    },
  },
};
</script>
